module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/babel-runtime/core-js/is-iterable.js
// module id = 69
// module chunks = 0